/**
 * MODULE: domain/pages/frontend/context/PagesEditorViewModeContext.tsx
 * PURPOSE: Distinguish authenticated editor vs anonymous public share rendering.
 * RECENT: 2026-05-24 [2.2.1150] — `public` mode hides CRM chrome and app nav on anonymous share views.
 */

import { createContext, useContext, type ReactNode } from 'react';

export type PagesEditorViewMode = 'editor' | 'public';

const PagesEditorViewModeContext = createContext<PagesEditorViewMode>('editor');

type ProviderProps = {
  mode: PagesEditorViewMode;
  children: ReactNode;
};

export function PagesEditorViewModeProvider({ mode, children }: ProviderProps) {
  return (
    <PagesEditorViewModeContext.Provider value={mode}>{children}</PagesEditorViewModeContext.Provider>
  );
}

export function usePagesEditorViewMode(): PagesEditorViewMode {
  return useContext(PagesEditorViewModeContext);
}

export function useIsPagesPublicView(): boolean {
  return usePagesEditorViewMode() === 'public';
}
